(function(){
  var DATA=(window.vehicleFitmentData||[]).filter(function(x){return !x.status||String(x.status).toLowerCase()==='active'});
  var productBaseUrl='/products/';
  var fallbackLink='/pages/customize-your-wrap';
  var pageSize=24, shown=pageSize, searchTerm='', selectedMake='', selectedModel='', selectedYear='';
  var renderTimer=null, suggestionRaf=null, suppressClickUntil=0;
  var el={
    search:document.getElementById('vf-search'),
    make:document.getElementById('vf-make-filter'),
    model:document.getElementById('vf-model-filter'),
    year:document.getElementById('vf-year-filter'),
    makeList:document.getElementById('vf-make-options'),
    modelList:document.getElementById('vf-model-options'),
    yearList:document.getElementById('vf-year-options'),
    results:document.getElementById('vf-results'),
    count:document.getElementById('vf-count'),
    reset:document.getElementById('vf-reset'),
    load:document.getElementById('vf-load'),
    topBrands:document.getElementById('vf-top-brands')
  };
  function esc(s){return String(s||'').replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]})}
  function norm(s){return String(s||'').trim()}
  function lower(s){return norm(s).toLowerCase()}
  function yearLabel(x){var a=norm(x.yearFrom),b=norm(x.yearTo);if(a&&b)return a===b?a:a+'-'+b;if(a)return a;if(b)return b;return 'Year not listed'}
  function countryLabel(x){return norm(x.country)||'Country not listed'}
  function cleanProductHandle(h){h=norm(h);if(!h)return '';h=h.replace(/^https?:\/\/[^\/]+\/products\//i,'');h=h.replace(/^\/products\//i,'');h=h.replace(/^\/+|\/+$/g,'');return h;}
  function rowProductHandle(x){return cleanProductHandle(x.productHandle||x.product_handle||x.Product_Handle||'')}
  function marketCountry(){return String(window.v2VehicleMarketCountry||'AU').trim().toUpperCase()}
  function marketProductHandle(h){
    h=cleanProductHandle(h);
    if(!h)return '';
    if(marketCountry()==='AU')return h.replace(/-intl$/i,'');
    return /-intl$/i.test(h)?h:h+'-intl';
  }
  function productUrlFromHandle(h){h=marketProductHandle(h);return h ? productBaseUrl+h : fallbackLink}
  function bestProductHandle(rows){var counts={},best='',bestCount=0;rows.forEach(function(x){var h=rowProductHandle(x);if(!h)return;counts[h]=(counts[h]||0)+1;if(counts[h]>bestCount){best=h;bestCount=counts[h]}});return best}
  function coversYear(x,y){
    if(!y)return true;
    var yf=parseInt(x.yearFrom,10),yt=parseInt(x.yearTo,10),yy=parseInt(y,10);
    if(isNaN(yy))return true;
    if(!isNaN(yf)&&!isNaN(yt))return yy>=yf&&yy<=yt;
    if(!isNaN(yf))return yy===yf;
    if(!isNaN(yt))return yy===yt;
    return false;
  }
  function uniq(arr){var seen={},out=[];arr.forEach(function(v){v=norm(v);var key=lower(v);if(v&&!seen[key]){seen[key]=1;out.push(v)}});return out.sort(function(a,b){return a.localeCompare(b,undefined,{numeric:true,sensitivity:'base'})})}
  function terms(){return lower(searchTerm).split(/\s+/).filter(Boolean)}
  function textMatch(value, filter){value=lower(value);filter=lower(filter);return !filter || value.indexOf(filter)>-1}
  function exactMatch(value, filter){return !filter || lower(value)===lower(filter)}
  function isYearToken(w){return /^\d{4}$/.test(String(w||''))}

  /* Fast lookup maps so the dropdowns do not scan all rows on every tap/letter. */
  var makeDisplay={}, rowsByMake={}, modelDisplayByMake={}, rowsByMakeModel={}, yearsByMakeModel={};
  DATA.forEach(function(x){
    var mk=lower(x.make), md=lower(x.model);
    if(!mk)return;
    if(!makeDisplay[mk])makeDisplay[mk]=norm(x.make);
    if(!rowsByMake[mk])rowsByMake[mk]=[];
    rowsByMake[mk].push(x);
    if(md){
      if(!modelDisplayByMake[mk])modelDisplayByMake[mk]={};
      if(!modelDisplayByMake[mk][md])modelDisplayByMake[mk][md]=norm(x.model);
      var key=mk+'|'+md;
      if(!rowsByMakeModel[key])rowsByMakeModel[key]=[];
      rowsByMakeModel[key].push(x);
    }
  });
  function sortedValuesFromMap(obj){return Object.keys(obj||{}).map(function(k){return obj[k]}).sort(function(a,b){return a.localeCompare(b,undefined,{numeric:true,sensitivity:'base'})})}
  var allMakes=sortedValuesFromMap(makeDisplay);
  function makeKey(){return lower(selectedMake)}
  function modelKey(){return lower(selectedModel)}
  function makeIsExact(){return !!selectedMake && !!makeDisplay[makeKey()]}
  function modelIsExact(){return !!selectedModel && makeIsExact() && !!(modelDisplayByMake[makeKey()]||{})[modelKey()]}
  function getModelOptions(){return makeIsExact()?sortedValuesFromMap(modelDisplayByMake[makeKey()]):[]}
  function getYearOptions(){
    if(!makeIsExact()||!modelIsExact())return [];
    var key=makeKey()+'|'+modelKey();
    if(yearsByMakeModel[key])return yearsByMakeModel[key];
    var years=[];
    (rowsByMakeModel[key]||[]).forEach(function(x){
      var a=parseInt(x.yearFrom,10),b=parseInt(x.yearTo,10);
      if(!isNaN(a)&&!isNaN(b)){for(var y=a;y<=b&&y<=2035;y++)years.push(String(y))}
      else if(!isNaN(a))years.push(String(a));
      else if(!isNaN(b))years.push(String(b));
    });
    yearsByMakeModel[key]=uniq(years).sort(function(a,b){return parseInt(b,10)-parseInt(a,10)});
    return yearsByMakeModel[key];
  }
  function matchMakeForFilter(x){return !selectedMake || (makeIsExact()?exactMatch(x.make, selectedMake):textMatch(x.make, selectedMake))}
  function matchModelForFilter(x){return !selectedModel || (modelIsExact()?exactMatch(x.model, selectedModel):textMatch(x.model, selectedModel))}
  function wordMatchesVehicle(x,w){
    if(isYearToken(w))return coversYear(x,w);
    var hay=lower([x.make,x.model,x.yearFrom,x.yearTo,x.country,x.sku].join(' '));
    return hay.indexOf(w)>-1;
  }
  function passesSearch(x){var t=terms();if(!t.length)return true;return t.every(function(w){return wordMatchesVehicle(x,w)})}
  function rowPassesFilters(x){
    if(!matchMakeForFilter(x))return false;
    if(!matchModelForFilter(x))return false;
    if(selectedYear&&!coversYear(x,selectedYear))return false;
    if(!passesSearch(x))return false;
    return true;
  }
  function scoreRow(x,t){
    var hay=lower([x.make,x.model,x.yearFrom,x.yearTo,x.country,x.sku].join(' '));
    var s=0;
    t.forEach(function(w){
      if(isYearToken(w)&&coversYear(x,w))s+=25;
      else if(hay.indexOf(w)>-1)s+=10;
      if(lower(x.make+' '+x.model).indexOf(w)>-1)s+=20;
      if(String(x.yearFrom).indexOf(w)>-1||String(x.yearTo).indexOf(w)>-1)s+=12;
    });
    if(selectedMake&&textMatch(x.make,selectedMake))s+=30;
    if(selectedModel&&textMatch(x.model,selectedModel))s+=35;
    if(selectedYear&&coversYear(x,selectedYear))s+=25;
    return s;
  }
  function filteredRows(){return DATA.filter(rowPassesFilters)}
  function compactCountries(rows){var vals=uniq(rows.map(function(x){return countryLabel(x)}));return vals.length<=4?vals.join(', '):vals.slice(0,4).join(', ')+' +'+(vals.length-4)+' more'}
  function modelSummary(rows){var models=uniq(rows.map(function(x){return x.model}));return models.length<=3?models.join(' / '):models.slice(0,3).join(' / ')+' +'+(models.length-3)+' more models'}
  function makeSummary(rows){var makes=uniq(rows.map(function(x){return x.make}));return makes.length<=3?makes.join(' / '):makes.slice(0,3).join(' / ')+' +'+(makes.length-3)+' more makes'}
  function representativeImage(rows){var counts={},best='',bestCount=0;rows.forEach(function(x){var im=norm(x.image);if(!im)return;counts[im]=(counts[im]||0)+1;if(counts[im]>bestCount){best=im;bestCount=counts[im]}});return best}
  function uniqueFitments(rows){
    var seen={},out=[];
    rows.forEach(function(x){var key=lower([x.make,x.model,yearLabel(x),countryLabel(x)].join('|'));if(!seen[key]){seen[key]=1;out.push(x)}});
    out.sort(function(a,b){return (a.make||'').localeCompare(b.make||'')||(a.model||'').localeCompare(b.model||'')||yearLabel(a).localeCompare(yearLabel(b),undefined,{numeric:true})||countryLabel(a).localeCompare(countryLabel(b))});
    return out;
  }
  function groupBySku(rows){
    var map={},groups=[];
    rows.forEach(function(x){var key=norm(x.sku)||('NO-SKU-'+norm(x.image)+'-'+norm(x.make));if(!map[key]){map[key]={sku:key,rows:[],_score:0};groups.push(map[key])}map[key].rows.push(x)});
    var t=terms();
    groups.forEach(function(g){
      var maxScore=0;g.rows.forEach(function(r){maxScore=Math.max(maxScore,scoreRow(r,t))});
      g._score=maxScore;g.image=representativeImage(g.rows);g.productHandle=bestProductHandle(g.rows);g.productUrl=productUrlFromHandle(g.productHandle);g.fitments=uniqueFitments(g.rows);g.makes=makeSummary(g.rows);g.models=modelSummary(g.rows);g.countries=compactCountries(g.rows);
    });
    groups.sort(function(a,b){return (b._score-a._score)||a.makes.localeCompare(b.makes)||a.models.localeCompare(b.models)||a.sku.localeCompare(b.sku)});
    return groups;
  }

  var comboOptions={make:allMakes,model:[],year:[]};
  var activeCombo='';
  function getCombo(kind){
    if(kind==='make')return {input:el.make,panel:el.makeList,options:comboOptions.make};
    if(kind==='model')return {input:el.model,panel:el.modelList,options:comboOptions.model};
    if(kind==='year')return {input:el.year,panel:el.yearList,options:comboOptions.year};
    return null;
  }
  function rankedOptions(options, term){
    term=lower(term);
    var limit=45;
    if(!term)return options.slice(0,limit);
    var starts=[], contains=[];
    for(var i=0;i<options.length;i++){
      var v=options[i], lv=lower(v);
      if(lv.indexOf(term)===0)starts.push(v);
      else if(lv.indexOf(term)>-1)contains.push(v);
      if(starts.length>=limit)break;
    }
    return starts.concat(contains).slice(0,limit);
  }
  function hideSuggestions(kind){var c=getCombo(kind);if(!c)return;c.panel.hidden=true;c.input.setAttribute('aria-expanded','false')}
  function hideAllSuggestions(){['make','model','year'].forEach(hideSuggestions);activeCombo=''}
  function suppressNextPageClick(){
    /* Mobile browsers can fire a delayed click after pointerdown.
       Keep that follow-up click from reaching buttons/cards underneath the dropdown. */
    suppressClickUntil=Date.now()+650;
  }
  function showSuggestions(kind){
    var c=getCombo(kind);if(!c||c.input.disabled){hideSuggestions(kind);return;}
    activeCombo=kind;
    if(suggestionRaf)cancelAnimationFrame(suggestionRaf);
    suggestionRaf=requestAnimationFrame(function(){
      var vals=rankedOptions(c.options||[], c.input.value);
      if(vals.length){
        c.panel.innerHTML=vals.map(function(v){return '<button type="button" class="vf-suggestion" role="option" data-value="'+esc(v)+'">'+esc(v)+'</button>';}).join('');
      }else{
        c.panel.innerHTML='<div class="vf-suggestion-empty">No matching option. Try another spelling.</div>';
      }
      c.panel.hidden=false;
      c.input.setAttribute('aria-expanded','true');
    });
  }
  function updateFilterControls(){
    comboOptions.make=allMakes;
    if(makeIsExact()){
      comboOptions.model=getModelOptions();
      el.model.disabled=false;
      el.model.placeholder='2. Type or select model';
    }else{
      comboOptions.model=[];
      el.model.disabled=true;
      el.model.placeholder=selectedMake?'Choose a listed make':'2. Select make first';
      selectedModel='';el.model.value='';
    }
    if(makeIsExact()&&modelIsExact()){
      comboOptions.year=getYearOptions();
      el.year.disabled=false;
      el.year.placeholder='3. Type or select year';
    }else{
      comboOptions.year=[];
      el.year.disabled=true;
      el.year.placeholder=selectedModel?'Choose a listed model':'3. Select model first';
      selectedYear='';el.year.value='';
    }
  }
  function renderFitmentRows(rows){
    var display=rows.slice(0,70).map(function(x){return '<div class="vf-fitment-row"><strong>'+esc(x.make+' '+x.model)+'</strong><br><span>'+esc(yearLabel(x))+' • '+esc(countryLabel(x))+'</span></div>'}).join('');
    if(rows.length>70)display+='<div class="vf-fitment-row">+'+esc(rows.length-70)+' more compatible vehicles</div>';
    return display;
  }
  function render(){
    updateFilterControls();
    var rows=filteredRows();
    var groups=groupBySku(rows);
    var visible=groups.slice(0,shown);
    el.count.textContent=groups.length?(groups.length+' matching wheel option'+(groups.length===1?'':'s')+' found for '+rows.length+' vehicle fitment'+(rows.length===1?'':'s')):'No matching vehicles found';
    if(!groups.length){
      el.results.className='';
      el.results.innerHTML='<div class="vf-empty"><strong>Can’t find your vehicle?</strong><br>Send us your vehicle make, model, year, and a steering wheel photo. We will check compatibility for you.</div>';
      el.load.style.display='none';
      return;
    }
    el.results.className='vf-grid';
    el.results.innerHTML=visible.map(function(g){
      return '<div class="vf-card" role="link" tabindex="0" data-url="'+esc(g.productUrl)+'" aria-label="View suitable wrap for '+esc(g.makes+' '+g.models)+'">'+
        '<div class="vf-img-wrap"><img loading="lazy" src="'+esc(g.image)+'" alt="'+esc(g.makes+' '+g.models+' steering wheel')+'"></div>'+
        '<div class="vf-body">'+
          '<div class="vf-make">'+esc(g.makes)+'</div>'+
          '<div class="vf-model">'+esc(g.models)+'</div>'+
          '<div class="vf-small">Compare this steering wheel with yours. If it matches, click View Suitable Wrap to see matching wrap options.</div>'+
          '<div class="vf-meta"><span class="vf-chip">'+(g.fitments.length===1?'Wheel used in 1 vehicle':'Wheel used in '+esc(g.fitments.length)+' vehicles')+'</span></div>'+
          '<details class="vf-list"><summary>More details of models</summary><div class="vf-fitments">'+renderFitmentRows(g.fitments)+'</div></details>'+
          '<a class="vf-btn" href="'+esc(g.productUrl)+'">View Suitable Wrap</a>'+
        '</div>'+
      '</div>';
    }).join('');
    el.load.style.display=groups.length>shown?'block':'none';
  }
  function renderNow(){shown=pageSize;render()}
  function scheduleRender(delay){
    clearTimeout(renderTimer);
    renderTimer=setTimeout(function(){shown=pageSize;render()}, typeof delay==='number'?delay:240);
  }
  function populateTopBrands(){
    var top=['Toyota','Ford','BMW','Mercedes-Benz','Holden','Nissan','Mazda','Volkswagen','Subaru','Isuzu','BYD'];
    el.topBrands.innerHTML=top.filter(function(b){return makeDisplay[lower(b)]}).map(function(b){return '<button type="button" class="vf-brand-pill" data-brand="'+esc(b)+'">'+esc(b)+'</button>'}).join('');
  }
  function setBrandActive(){Array.prototype.forEach.call(document.querySelectorAll('.vf-brand-pill'),function(btn){btn.classList.toggle('active',btn.getAttribute('data-brand')===selectedMake)})}
  function pickSuggestion(kind, value){
    if(kind==='make'){
      selectedMake=value;selectedModel='';selectedYear='';el.make.value=value;el.model.value='';el.year.value='';
    }else if(kind==='model'){
      selectedModel=value;selectedYear='';el.model.value=value;el.year.value='';
    }else if(kind==='year'){
      selectedYear=value;el.year.value=value;
    }
    updateFilterControls();
    hideAllSuggestions();
    setBrandActive();
    scheduleRender(40);
  }
  function bindCombo(kind, input, panel){
    input.addEventListener('focus',function(){showSuggestions(kind)});
    input.addEventListener('click',function(){showSuggestions(kind)});
    input.addEventListener('input',function(){
      if(kind==='make'){
        selectedMake=input.value;selectedModel='';selectedYear='';el.model.value='';el.year.value='';
      }else if(kind==='model'){
        selectedModel=input.value;selectedYear='';el.year.value='';
      }else if(kind==='year'){
        selectedYear=input.value;
      }
      updateFilterControls();
      showSuggestions(kind);
      setBrandActive();
      scheduleRender(280);
    });
    function onOptionEvent(e){
      var btn=e.target.closest('.vf-suggestion[data-value]');
      if(!btn)return;
      e.preventDefault();
      e.stopPropagation();
      if(e.stopImmediatePropagation)e.stopImmediatePropagation();
      suppressNextPageClick();
      pickSuggestion(kind, btn.getAttribute('data-value'));
    }
    panel.addEventListener('pointerdown',onOptionEvent, true);
    panel.addEventListener('touchstart',onOptionEvent, {capture:true, passive:false});
    panel.addEventListener('mousedown',onOptionEvent, true);
    panel.addEventListener('click',function(e){
      var btn=e.target.closest('.vf-suggestion[data-value]');
      if(!btn)return;
      e.preventDefault();
      e.stopPropagation();
      if(e.stopImmediatePropagation)e.stopImmediatePropagation();
    }, true);
    input.addEventListener('keydown',function(e){if(e.key==='Escape')hideAllSuggestions();if(e.key==='ArrowDown')showSuggestions(kind)});
  }
  bindCombo('make',el.make,el.makeList);
  bindCombo('model',el.model,el.modelList);
  bindCombo('year',el.year,el.yearList);
  document.addEventListener('click',function(e){
    if(Date.now()<suppressClickUntil){
      e.preventDefault();
      e.stopPropagation();
      if(e.stopImmediatePropagation)e.stopImmediatePropagation();
      return false;
    }
  }, true);
  document.addEventListener('pointerdown',function(e){
    if(Date.now()<suppressClickUntil){
      e.preventDefault();
      e.stopPropagation();
      if(e.stopImmediatePropagation)e.stopImmediatePropagation();
      return false;
    }
    if(!e.target.closest('.vf-combo'))hideAllSuggestions();
  }, true);
  el.search.addEventListener('input',function(e){searchTerm=e.target.value;scheduleRender(260)});
  el.reset.addEventListener('click',function(){
    searchTerm='';selectedMake='';selectedModel='';selectedYear='';shown=pageSize;
    el.search.value='';el.make.value='';el.model.value='';el.year.value='';
    hideAllSuggestions();setBrandActive();render();
  });
  el.load.addEventListener('click',function(){shown+=pageSize;render()});
  el.topBrands.addEventListener('click',function(e){
    var b=e.target.getAttribute('data-brand');if(!b)return;
    searchTerm='';selectedMake=b;selectedModel='';selectedYear='';shown=pageSize;
    el.search.value='';el.make.value=b;el.model.value='';el.year.value='';
    hideAllSuggestions();setBrandActive();render();
  });
  function ignoreCardClick(target){return target.closest('a')||target.closest('details')||target.closest('summary')||target.closest('button')||target.closest('input')||target.closest('select')||target.closest('textarea')}
  el.results.addEventListener('click',function(e){var card=e.target.closest('.vf-card[data-url]');if(!card||ignoreCardClick(e.target))return;var url=card.getAttribute('data-url');if(url)window.location.href=url});
  el.results.addEventListener('keydown',function(e){if((e.key==='Enter'||e.key===' ')&&e.target.classList.contains('vf-card')){e.preventDefault();var url=e.target.getAttribute('data-url');if(url)window.location.href=url}});
  populateTopBrands();
  updateFilterControls();
  render();
})();
